import Link, {LinkProps} from '@mui/material/Link';

import {styled} from '@mui/material/styles';

export const CLink = styled(Link)<LinkProps>(
  (/* { theme } */) => ({
  }),
);
